import Color from 'color';
import styled, {css} from 'styled-components';

import {ms} from '../../../../styles/normalizeSize';
import {getColor} from '../../../../styles/utils';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';
import {platform} from '../../../../utils/platform';

export const Container = styled(View)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: ${ms(4)} ${ms(8)};
  background: ${p => Color(getColor('static.black')(p)).alpha(0.5).toString()};
  border-radius: ${ms(8)};

  ${() =>
    platform.isWeb &&
    css`
      display: inline-flex;
    `}
`;

export const Dot = styled(View)`
  width: ${ms(12)};
  height: ${ms(12)};
  min-width: ${ms(12)};
  min-height: ${ms(12)};
  border-radius: ${ms(12)};
  background: ${getColor('error')};
  margin-right: ${ms(8)};
`;

export const Label = styled(Text)`
  font-size: ${ms(14)};
  line-height: ${ms(20)};
  color: ${getColor('text.white')};
`;
